<script setup lang="ts">
defineEmits(["click"])
</script>
<template>
  <button
    class="group inline-flex cursor-pointer items-center justify-center rounded-full bg-zinc-100 p-1.5 text-zinc-500 hover:bg-zinc-200 hover:text-zinc-600 focus:ring-2 focus:ring-offset-2 focus:outline-hidden sm:text-sm"
    @click="$emit('click')"
  >
    <SvgoPikaClose
      class="size-5 transition motion-safe:group-hover:rotate-90"
    />
  </button>
</template>
